module.exports = __webpack_public_path__ + "img/nezam-senfi.702dd29.svg";